import { Favicon } from "@components/Favicon";
import { SmartBannerMeta } from "@lib/analytics/SmartBanner";
import { activeSiteSmartBanner } from "@config/site/site-config";
import AudioEyeScript from "@lib/accessibility/audioEyeScript";

export const DocumentHead = () => {
    return (
        <>
            <link
                rel="preload"
                href="/assets/fonts/Unica77LLTT-Regular.woff2"
                as="font"
                type="font/woff2"
                crossOrigin="anonymous"
            />
            <link
                rel="preload"
                href="/assets/fonts/Unica77LLTT-Bold.woff2"
                as="font"
                type="font/woff2"
                crossOrigin="anonymous"
            />
            <Favicon />
            <meta name="format-detection" content="telephone=no, date=no, email=no, address=no" />
            <meta name="referrer" content="same-origin" />
            <style>{`.grecaptcha-badge { visibility: hidden; z-index: 5000 !important; position: static !important }`}</style>
            <AudioEyeScript />
            {activeSiteSmartBanner && (
                <SmartBannerMeta
                    googleAppId={activeSiteSmartBanner.googleAppId}
                    iOSAppId={activeSiteSmartBanner.iOSAppId}
                />
            )}
        </>
    );
};
